export default __webpack_public_path__ + "static/media/022-prism.95f9e7f6.svg";